module.exports = {
      id: "arcade-usage",
      viewBox: "0 0 19.915 20.731",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#arcade",
      toString: function () {
        return this.url;
      }
    }